/* eslint-disable class-methods-use-this, import/no-extraneous-dependencies */
import useJwt from '@/auth/jwt/useJwt'

export default class AuditsService {
  static get(auditableType, auditableId) {
    return useJwt.get(`/audits/${auditableType}/${auditableId}`)
  }
}
